import store from '@/store'
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'

interface State {
  course: object
  autoPlayNext: boolean
  currentPlayChapterIndex: number
  currentPlayCourseWareIndex: number
}

// interface GetCourseParams {
//   courseId: string
//   trainClassId: string
//   extParams: string
// }
@Module({
  namespaced: true,
  name: 'Play',
  store,
  dynamic: true
})
class Play extends VuexModule implements State {
  course: object = {}
  autoPlayNext = true
  currentPlayChapterIndex = 0
  currentPlayCourseWareIndex = 0
  // actions = {
  @Action
  changeAutoPlayNext(value: boolean) {
    this.CHANGE_AUTO_PLAY_NEXT(value)
  }
  @Action
  setIndexInfo(indexInfo: { chapterIndex: number; courseWareIndex: number }) {
    this.CHANGE_INDEX_INFO(indexInfo)
  }
  // }

  @Mutation
  CHANGE_AUTO_PLAY_NEXT(value: boolean) {
    this.autoPlayNext = value
  }
  @Mutation
  CHANGE_INDEX_INFO(indexInfo: { chapterIndex: number; courseWareIndex: number }) {
    this.currentPlayChapterIndex = indexInfo.chapterIndex
    this.currentPlayCourseWareIndex = indexInfo.courseWareIndex
  }
}

export default getModule(Play)
